import { LOCALSTORAGE_TOKEN, LOCALSTORAGE_USER_IS_MANAGER } from "../config";
import { PATH_LOGIN, PATH_DIARY } from "../routes";
import { route } from "preact-router";

export const isAuthenticated = () =>
  localStorage.getItem(LOCALSTORAGE_TOKEN) != null;

export const isManager = () => {
  if (!JSON.parse(localStorage.getItem(LOCALSTORAGE_USER_IS_MANAGER)))
    route(PATH_DIARY);
};

export const logout = () => {
  localStorage.clear();
  route(PATH_LOGIN, true);
};



// WEBPACK FOOTER //
// ./src/support/auth.js